var dyHelpers = require('../utils/_dyHelpers');

class mMinicartEmpty extends HTMLDivElement {
    constructor() {
        super();

        // Bind this
        this.onCloseEmptyMinicart = this.onCloseEmptyMinicart.bind(this);
    }

    connectedCallback() {
        document.addEventListener('oSidebar:close', this.onCloseEmptyMinicart);
        var currentDyData = window.currentDyData;
        var dyData = dyHelpers.setDyRecommendationContext();
        if (!currentDyData) {
            currentDyData = dyData;
        }
        this.currentDyData = currentDyData;
        delete window.currentDyData;

        document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
            detail: {
                productCount: 0,
            },
        }));
    }

    disconnectedCallback() {
        document.removeEventListener('oSidebar:close', this.onCloseEmptyMinicart);
    }

    onCloseEmptyMinicart(event) {
        if (event && event.detail && event.detail.sidebarId === 'o-sidebar-miniCart') {
            if (this.currentDyData) { // reset dyData to previous state
                dyHelpers.setDyRecommendationContext(this.currentDyData, true);
            }
        }
    }
}

customElements.define('m-minicart-empty', mMinicartEmpty, {
    extends: 'div'
});
